<template>
    <div class="home">
        <WelcomePopup></WelcomePopup>
        <!-- on small screens the Holiday Breakdown is collapsed/hidden, so offer the switch here too -->
        <div class="mobile-currency-switch">
            <CurrencySwitch></CurrencySwitch>
        </div>
        <DateAccommodationCheck></DateAccommodationCheck>
        <!-- 
        <h2>{{ $t("booking notes") }}</h2>
        <p>{{ $t("Holidays start and end on a Monday, except the Early & Late Sumer Specials and September weeks when extra days may be added. See website for details. Please phone us on 01825 748318 to book Houseparty individual rates which cannot be booked online.") }}</p>
         -->

        <h2>{{ $t("welcome booking title") }}</h2>
        <p style="margin-bottom:0.7rem">
            {{ $t("welcome booking paragraph_1") }}
        </p>
        <p style="margin-bottom:0.7rem">
            {{ $t("welcome booking paragraph_2") }}
        </p>
        <p style="margin-bottom:0.7rem">
            {{ $t("welcome booking paragraph_3") }}
        </p>
        <p style="margin-bottom:0.7rem">
            {{ $t("welcome booking paragraph_4") }}
            <a href="mailto:info@springharvestholidays.com"
                >info@springharvestholidays.com</a
            >.
        </p>
    </div>
</template>

<script>
// @ is an alias to /src
import DateAccommodationCheck from "@/components/DateAccommodationCheck.vue";
import CurrencySwitch from "@/components/CurrencySwitch.vue";
import WelcomePopup from "@/components/WelcomePopup.vue";
import { mapGetters } from "vuex";

export default {
    name: "Home",
    components: {
        DateAccommodationCheck,
        CurrencySwitch,
        WelcomePopup
    },
    mounted() {
        // set the currency once: injected value (Agape / booking/params) or GBP by default;
        // after that the customer changes it with the switch button in the Holiday Breakdown
        if (!this.getCurrency.popupShown) {
            this.$store.commit("UPDATE_CURRENCY", bookingCurToInject || "GBP");
        }
    },
    created() {},
    computed: {
        ...mapGetters(["getCurrency"])
    }
};
</script>

<style scoped>
@media (min-width: 1024px) {
    .mobile-currency-switch {
        display: none;
    }
}
.mobile-currency-switch {
    margin-bottom: 10px;
}
</style>
